import { Input, InputProps } from "@nextui-org/react";
import { FC } from "react";

interface IProps extends Omit<InputProps, "onValueChange"> {
  onValueChange: (value: string) => void;
}

export const InputField: FC<IProps> = (props) => {
  const handleValueChange = (value: string) => {
    const replaced = value.replaceAll(",", ".");
    const cleaned = replaced.replace(/[^0-9.]/g, "");
    props.onValueChange(cleaned);
  };

  return (
    <Input
      {...props}
      onValueChange={handleValueChange}
      classNames={{
        inputWrapper: "!bg-brand-700",
        label: "!text-white pe-0",
        input: "!text-white",
        innerWrapper: "text-sm",
      }}
    />
  );
};
